import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledCheckBox } from './styles/StyledCheckBox';
import { CONTROLLED_INPUT_INVALID, } from '../../globals';

class CheckBox extends Component {
  render() {
    const { value, inputState, onChange, children, name,} = this.props;

    return (
      <StyledCheckBox>
        <label className="container">
          {children}
          <input type="checkbox" checked={value} onChange={e => {}}/>
          <span className={'checkmark' + (inputState === CONTROLLED_INPUT_INVALID ? ' error' : '')} onClick={e => onChange(!value, name)}></span>
        </label>
      </StyledCheckBox>
    );
  }
}

CheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  inputState: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired, 
};


export default CheckBox;





// WEBPACK FOOTER //
// ./src/common/CheckBox/CheckBox.js